import { SUPPORT_CONTACT } from '../constants';

/** Append the standard support-contact line to a user-facing error message. */
export function withSupport(message: string): string {
  return `${message} ${SUPPORT_CONTACT}`;
}
